var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page dashboard admin"},[_c('statistics'),_c('case-repayment-statistics'),_c('case-collection-distribution')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }